export const ADD_ALL_MEETINGS = "ADD_ALL_MEETINGS";
export const REMOVE_ALL_MEETINGS = "REMOVE_ALL_MEETINGS";
export const EDIT_MEETING_BY_INDEX = "EDIT_MEETING_BY_INDEX";
export const REMOVE_MEETING_BY_INDEX = "REMOVE_MEETING_BY_INDEX";
